import './InputTextarea.scss';
import { forwardRef } from "react";
import { InputTextarea as PrInputTextArea } from 'primereact/inputtextarea';
import classNames from 'classnames';

const InputTextarea = forwardRef((props, ref) => {
  const { className, ...restProps } = props

  return <PrInputTextArea ref={ref} className={classNames(`InputTextarea`, className)} {...restProps} />
})


export default InputTextarea